import React from "react";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";

import Copyright from "../../components/common/Copyright";
import img from "../../images/login-splash-2.jpg";
import logo from "../../images/tcmpc-logo.png";

import LoginRoute from "./LoginRoute";
import RegisterRoute from "./RegisterRoute";
import ResetPasswordRoute from "./ResetPasswordRoute";

const Backdrop = styled.div`
  min-height: 100%;
  background-image: url(${img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  align-items: center;
`;

const Center = styled.div`
  max-width: 50rem;
  margin: 0 auto;
  padding: 2rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const LoginBox = styled.div`
  /* display: flex; */
  /* flex-direction: column; */
  gap: 1rem;
  padding: 4rem;
  border: solid 1px #ddd;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 0.5rem;
  box-sizing: border-box;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

const Tagline = styled.div`
  font-size: 2rem;
  margin: 1.5rem 0;
  text-align: center;
`;

interface Props {
  onLanguageChange: (value: string) => void;
}

const LoginRoutes = (props: Props) => {
  return (
    <Backdrop>
      <Center>
        <Layout>
          <LoginBox>
            <Logo>
              <img alt="TCMPC Logo" src={logo} style={{ maxWidth: "25rem" }} />
            </Logo>
            <Routes>
              <Route path="/" element={<LoginRoute />} />
              <Route path="/register" element={<RegisterRoute />} />
              <Route path="/reset" element={<ResetPasswordRoute />} />
            </Routes>
          </LoginBox>
          <Tagline>
            <strong>Targeted</strong> Success with <strong>Quality</strong>{" "}
            Curriculum and <strong>Aligned</strong> Content
          </Tagline>
          <div style={{ textAlign: "center" }}>
            <Copyright />
          </div>
        </Layout>
      </Center>
    </Backdrop>
  );
};

export default LoginRoutes;
